import { render, staticRenderFns } from "./TkPolicy.vue?vue&type=template&id=3b526de6&"
import script from "./TkPolicy.vue?vue&type=script&lang=js&"
export * from "./TkPolicy.vue?vue&type=script&lang=js&"
import style0 from "./TkPolicy.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports